import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {OrganizationService} from '../../apiModule1';

export const organizationResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: OrganizationService = inject(OrganizationService)) => {
  return service.apiOrganizationGet({}, 'body', false, {transferCache: false});
};
